import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Card, Col, Form, Row, Select, InputNumber, Modal, Checkbox, message } from 'antd'
import '../../css/schedule.scss'
import { constants } from '../../constants'
import Schedule from './exercise.sched'
import Configure from './exercise.conf'
import {
  CloseCircleOutlined,
  DeleteFilled,
  ExclamationCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons'
import serviceInterface from '../../services/service.interface'
import { EXERCISE_ACTION_TYPE } from '../../services/schedule.service'
import { setExercises } from '../../store/action/schedule.action'
import { resolveWeekCell, currentWeekFromSurgery } from './tracpatch.week.defaults'
import moment from 'moment'
import _ from 'lodash'

const ExerciseRow = (props) => {
  var {
    _id,
    exercise: { image, name },
    regimen,
    ...rest
  } = props?.exercise
  var form = useRef()
  var wrapRef = useRef()

  const [height, setHeight] = useState(0)
  var [skiponsurgerydate, setSkip] = useState(true)

  useEffect(() => {
    var hght = wrapRef.current ? wrapRef.current.offsetHeight : 0
    setHeight(hght)
  }, [wrapRef.current?.offsetHeight])

  useEffect(() => {
    props.scroll &&
      wrapRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
  }, [props.scroll])

  var editChange = () => setHeight(wrapRef.current.offsetHeight)

  // Reps required for the patient's CURRENT post-op week for a TracPatch
  // exercise, resolved through the clinic→tier→master chain (no per-patient
  // overrides yet at add time). Used to seed the add form's REPEAT and to
  // detect whether the admin changed it on save. Returns null for
  // non-TracPatch / missing config.
  var tracpatchCurrentWeekReps = (ex) => {
    if (!ex || ex.type !== 'TracPatch' || !ex.tracpatchConfig) return null
    var mc = ex.tracpatchConfig
    var surgeryDate =
      props.newPatient && props.newPatient.surgery && props.newPatient.surgery.date
    var curWeek = currentWeekFromSurgery(surgeryDate, 13)
    return resolveWeekCell(curWeek, 'reps', {
      repMilestoneByWeek: [],
      resolved: function (f) {
        return mc[f]
      },
      tierDefaults: mc.tierDefaults,
      clinicRepMilestoneByWeek: mc.rep_milestone_by_week,
      overrides: {},
    })
  }

  var disabled = () => {
    return false
    if (props.addBit) return false
    return (
      moment()
        .startOf('day')
        .isAfter(
          moment(props.newPatient?.surgery?.date)
            .add(rest.startdate, 'd')
            .startOf('day')
        ) &&
      moment()
        .startOf('day')
        .isAfter(
          moment(props.newPatient?.surgery?.date)
            .add(rest.enddate, 'd')
            .startOf('day')
        )
    )
  }
  var renderIntervalOptions = () => {
    return constants.INTERVAL_OPTIONS.map((data) => (
      <Select.Option style={{ fontSize: '1rem' }} value={data.index}>
        {data.name}
      </Select.Option>
    ))
  }

  var renderExerOpts = () => {
    var exercises = _.orderBy(props.exercises, ['name'])
    return exercises.map((exer) => (
      <Select.Option value={exer._id}>
        <div hidden>{exer.name}</div>
        <Row>
          <Col>
            <div className='exerImgBoxSmall'>
              <img
                className='exerImgSmall'
                src={constants.API_URL + exer.image}
              />
            </div>
          </Col>
          <Col>
            <Row className='exerHeaderSmall'>{exer.name}</Row>
          </Col>
        </Row>
      </Select.Option>
    ))
  }

  var renderInfo = () => {
    return (
      <Row
        hidden={props.addBit}
        align='middle'
        style={{ height: '100%', flexFlow: 'nowrap' }}
      >
        <Col>
          <div className='exerImgBox'>
            <img className='exerImg' src={constants.API_URL + image} />
          </div>
        </Col>
        <Col>
          <Row className='exerHeader'>{name}</Row>
          <Row className='exerDescp'>
            <Col>Regimen:&nbsp;</Col>
            <Col> {regimen.name}</Col>
          </Row>
        </Col>
      </Row>
    )
  }

  var renderConfForm = () => {
    return (
      <Row hidden={!props.addBit} align='middle' style={{ height: '100%' }}>
        <Col flex={'10%'}>&nbsp;</Col>
        <Col flex={'auto'}>
          <Row>
            <Col className='confHeader' flex={'100px'}>
              {' '}
              HOLD{' '}
            </Col>
            <Col className='confHeader' flex={'auto'}>
              <Row>
                <Form.Item className='addFormItem' name='hold'>
                  <InputNumber min={0} className='confInput' />
                </Form.Item>
                <Form.Item className='addFormItem' name='postfix'>
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    className='confInput'
                  >
                    <Select.Option value={'minutes'}>{'minutes'}</Select.Option>
                    <Select.Option value={'seconds'}>{'seconds'}</Select.Option>
                  </Select>
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className='confHeader' flex={'100px'}>
              {' '}
              REPEAT{' '}
            </Col>
            <Col className='confHeader' flex={'auto'}>
              <Form.Item className='addFormItem' name='repeat'>
                <InputNumber min={0} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col className='confHeader' flex={'100px'}>
              {' '}
              SET{' '}
            </Col>
            <Col className='confHeader' flex={'auto'}>
              <Form.Item className='addFormItem' name='set'>
                <InputNumber min={1} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
                        <Col className="confHeader" flex={"100px"}> DAILY </Col>
                        <Col className="confHeader" flex={"auto"}>
                            <Form.Item className="addFormItem" name="time">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>
                    </Row>
        </Col>
        <Col flex={'65px'}> </Col>
      </Row>
    )
  }

  var renderScheduleForm = () => {
    return (
      <Row hidden={!props.addBit} align='middle' style={{ height: '100%' }}>
        <Col flex={'10%'}>&nbsp;</Col>
        <Col flex={'auto'}>
          <Row style={{ height: '100%' }}>
            <Col className='confHeader' flex={'auto'}>
              <Form.Item
                name='startdate'
                className='addFormItem'
                rules={[
                  {
                    required: true,
                    message: 'enter startdate!',
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (
                        ((value || value === 0)  && value < getFieldValue('enddate')) ||
                        !getFieldValue('enddate')
                      )
                        return Promise.resolve()
                      return Promise.reject('invalid startdate')
                    },
                  }),
                ]}
              >
                <InputNumber />
               
              </Form.Item>
              <Checkbox
                checked={skiponsurgerydate}
                onChange={(e) => setSkip(e.target.checked)}
              >
                Skip on surgery date
              </Checkbox>
            </Col>
            <Col className='confHeader' flex={'auto'}>
              {' '}
              TO{' '}
            </Col>
            <Col className='confHeader' flex={'auto'}>
              <Form.Item
                className='addFormItem'
                name='enddate'
                rules={[
                  {
                    required: true,
                    message: 'enter enddate!',
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (
                        ((typeof value == 'number') && value > getFieldValue('startdate')) ||
                        !getFieldValue('startdate')
                      )
                        return Promise.resolve()
                      return Promise.reject('invalid enddate!')
                    },
                  }),
                ]}
              >
                <InputNumber />
              </Form.Item>
            </Col>
            <Col className='confHeader' flex={'auto'}>
              <Form.Item className='addFormItem' name='interval'>
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ minWidth: 120 }}
                  defaultValue={3}
                >
                  {renderIntervalOptions()}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col flex={'65px'}> </Col>
      </Row>
    )
  }

  var renderActions = () => {
    return (
      <>
        <Row
          hidden={props.addBit || (props.editPage && disabled())}
          align='middle'
          justify='center'
          style={{ height: '100%' }}
        >
          <DeleteFilled
            id={'deleteexe'}
            className='removeIcon'
            onClick={handleDeleteClick}
          />
        </Row>
        <Row
          hidden={!props.addBit}
          align='middle'
          justify='center'
          style={{ height: '100%' }}
          gutter={5}
        >
          <Col>
            <CloseCircleOutlined onClick={handleCancel} className='editIcon' />
          </Col>
          <Col>
            <PlusCircleOutlined onClick={handleAddClick} className='editIcon' />
          </Col>
        </Row>
      </>
    )
  }

  var handleDeleteClick = () => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want to delete this Exercise ?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: onDelete,
    })
  }

  var onDelete = () => {
    var exercises = serviceInterface
      .ScheduleService()
      .modifyExerciseArray(
        props.exercise,
        props.schedExercises,
        EXERCISE_ACTION_TYPE.DELETE
      )
    props.setExercises(exercises)
  }

  var handleCancel = () => {
    form.current.resetFields()
    props.onClose()
  }

  var handleAddClick = () => {
    form.current
      .validateFields()
      .then(({ startdate, enddate, repeat, time, set, ...rest }) => {
        var selectedEx = _.find(props.exercises, { _id: rest.exercise })
        // TracPatch reps rule (2026-10-16): the REPEAT entered here IS the
        // patient's rep target — the schedule row's `repeat` governs, the
        // same way the care plan row does for the clinic. No requiredReps
        // override is written; the REPEAT seed below is only a starting value.
        var tpOverrides
        var exercises = serviceInterface.ScheduleService().modifyExerciseArray(
          {
            skiponsurgerydate,
            startdate,
            enddate,
            _id: _.uniqueId('CUSTEXER'),
            hold: rest.hold + ' ' + rest.postfix,
            time: time ? time.toString() : '1',
            repeat: repeat.toString(),
            interval: rest.interval ? rest.interval : 7,
            set: set.toString(),
            exercise: selectedEx,
            tracpatchConfigOverrides: tpOverrides,
            regimen: {
              _id: 'CUSTOMREG',
              name: 'CUSTOM',
            },
          },
          props.schedExercises,
          EXERCISE_ACTION_TYPE.ADD
        )
        props.setExercises(exercises)
        form.current.resetFields()
        props.onClose()
      })
  }

  var handleUnselect = () => {
    props.setExercises(
      serviceInterface
        .ScheduleService()
        .disconnectExercise(props.exercise, props.schedExercises)
    )
  }

  return (
    <Form
      ref={form}
      hidden={props.hidden || disabled()}
      initialValues={{
        hold: '1',
        repeat: '1',
        time: '1',
        set: '1',
        postfix: 'seconds',
      }}
    >
      <div id={'exeschedview'} ref={wrapRef}>
        <Row className='exerciseRow'>
          <Col flex={'auto'}>
            {/* <Row className="connectorLine_1" /> */}
            <Row className='connectorLine_3' />
            {/* <Row className="connectorLine_2" /> */}
            <Row>
              <Col hidden={!props.highlight} className='higlightCol' />
              <Col className='exerciseCol divide' flex={'24%'}>
                <Card bordered={false} className='exerciseCard'>
                  {renderInfo()}
                  <Row
                    hidden={!props.addBit}
                    style={{ height: '100%' }}
                    align='middle'
                  >
                    <Form.Item
                      className='addFormItem'
                      style={{ width: '100%' }}
                      name='exercise'
                      Label='Exercise'
                      rules={[
                        {
                          message: 'Please select an exercise.',
                          required: true,
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        className='exerSelect'
                        placeholder='Select exercise'
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          option.children[0]?.props?.children
                            ?.toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(exerciseId) => {
                          // Block re-adding an exercise that's already on
                          // the patient's schedule. Surface the warning at
                          // pick time so the clinician doesn't fill out
                          // the rest of the form before learning.
                          var alreadyAdded = (props.schedExercises || []).some(function (s) {
                            return s && s.exercise && s.exercise._id === exerciseId
                          })
                          if (alreadyAdded) {
                            message.warning('This exercise is already on the patient\'s schedule.')
                            try { form.current.setFieldsValue({ exercise: undefined }) } catch (e) {}
                            return
                          }
                          // When a TracPatch exercise is picked, prefill
                          // the schedule's HOLD / REPEAT / SET fields from
                          // its master tracpatchConfig so the admin sees
                          // clinically-sensible defaults instead of "1".
                          // DAILY (time) stays at 1 — TracPatch is
                          // single-slot system-wide.
                          const ex = _.find(props.exercises, { _id: exerciseId })
                          if (!ex || ex.type !== 'TracPatch' || !ex.tracpatchConfig) return
                          const mc = ex.tracpatchConfig
                          const patch = {}
                          if (parseInt(mc.requiredHoldSeconds, 10) > 0) patch.hold = String(mc.requiredHoldSeconds)
                          // REPEAT seeds to the reps required for the patient's
                          // CURRENT week (clinic→tier→master), not a single
                          // static number. Admin can keep it (→ each week keeps
                          // its own rep milestone) or change it (→ flat reps for
                          // all weeks, handled on add in handleAddClick).
                          const curWeekReps = tracpatchCurrentWeekReps(ex)
                          if (curWeekReps != null && parseInt(curWeekReps, 10) > 0) patch.repeat = String(curWeekReps)
                          else if (parseInt(mc.requiredReps, 10) > 0) patch.repeat = String(mc.requiredReps)
                          if (parseInt(mc.requiredSets, 10) > 0) patch.set = String(mc.requiredSets)
                          patch.time = '1'
                          try { form.current.setFieldsValue(patch) } catch (e) {}
                        }}
                      >
                        {' '}
                        {renderExerOpts()}{' '}
                      </Select>
                    </Form.Item>
                  </Row>
                </Card>
              </Col>
              <Col className='exerciseColCenter divide' flex={'33%'}>
                <Card bordered={false} className='exerciseCard'>
                  <Col
                    onClick={handleUnselect}
                    hidden={!props.connect}
                    className='connectorLineMain'
                    style={{ height }}
                  />
                  <Configure
                    editPage={props.editPage}
                    connect={props.connect}
                    connected={props.connected}
                    editChange={editChange}
                    hidden={props.addBit}
                    settings={props.exercise}
                    add={props.addBit}
                    editOhers={props.edit}
                    setOthersEdit={(b) => props.setEdit(b)}
                  />
                  {renderConfForm()}
                </Card>
              </Col>
              <Col className='exerciseCol divide' flex={'33%'}>
                <Card bordered={false} className='exerciseCard'>
                  <Schedule
                    editPage={props.editPage}
                    hidden={props.addBit}
                    editOhers={props.edit}
                    setOthersEdit={(b) => props.setEdit(b)}
                    schedule={props.exercise}
                    editChange={editChange}
                  />
                  {renderScheduleForm()}
                </Card>
              </Col>
              <Col className='exerciseCol divide' flex={'10%'}>
                <Card bordered={false} className='exerciseCard'>
                  {renderActions()}
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Form>
  )
}

ExerciseRow.propTypes = {
  customer: PropTypes.object,
  exercise: PropTypes.object,
  exercises: PropTypes.array,
  addBit: PropTypes.bool,
  hidden: PropTypes.bool,
  setEdit: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    newPatient: state.patient.newpatient,
    exercises: state.exercise.exercises,
    schedExercises: state.schedule.exercises,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setExercises: (exercises) => dispatch(setExercises(exercises)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExerciseRow)
